var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('sds-page',{attrs:{"title":"Relatório de Pareceres Referenciais Vencidos ou Próximos do Vencimento"}},[_c('v-row',[_c('v-col',[_c(_setup.CardRelatorioParecerReferencial)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }